import { render } from "./ResetPasswordBanner.vue?vue&type=template&id=0438e50d"
import script from "./ResetPasswordBanner.vue?vue&type=script&lang=js"
export * from "./ResetPasswordBanner.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__